import React from 'react';
import { Button } from './ui/button';
import { Download, Loader2, Inbox, Clock, CheckCircle2, XCircle, X } from 'lucide-react';

const CHIPS = [
  { key: 'aTraiter', label: 'À traiter', icon: Inbox, cls: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-300 dark:border-amber-800', dot: 'text-amber-500', testid: 'sim-count-a-traiter' },
  { key: 'enCours', label: 'En cours', icon: Clock, cls: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/20 dark:text-blue-300 dark:border-blue-800', dot: 'text-blue-500', testid: 'sim-count-en-cours' },
  { key: 'signees', label: 'Signées', icon: CheckCircle2, cls: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-800', dot: 'text-emerald-500', testid: 'sim-count-signees' },
  { key: 'perdues', label: 'Perdues', icon: XCircle, cls: 'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-900/20 dark:text-rose-300 dark:border-rose-800', dot: 'text-rose-500', testid: 'sim-count-perdues' },
];

// Barre de synthèse en tête du Tableau de bord Simulation : compteurs cliquables (filtre par statut) + export Excel de la liste filtrée.
export const SimulationStatusBar = ({ counts = {}, onExport, exporting = false, active = 'all', onSelect }) => {
  const handleClick = (key) => {
    if (!onSelect) return;
    onSelect(active === key ? 'all' : key);
  };
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" data-testid="simulation-status-bar">
      <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-2">
        {CHIPS.map((c) => {
          const Icon = c.icon;
          const isActive = active === c.key;
          return (
            <button
              key={c.key}
              type="button"
              onClick={() => handleClick(c.key)}
              aria-pressed={isActive}
              className={`flex items-center gap-2 rounded-xl border px-3.5 py-2 transition-all cursor-pointer hover:shadow-sm ${c.cls} ${isActive ? 'ring-2 ring-offset-1 ring-current shadow-sm scale-[1.02]' : 'opacity-90 hover:opacity-100'}`}
              data-testid={c.testid}
            >
              <Icon className={`w-4 h-4 ${c.dot}`} />
              <span className="text-sm font-medium">{c.label}</span>
              <span className="text-base font-bold tabular-nums ml-0.5">{counts[c.key] ?? 0}</span>
            </button>
          );
        })}
        {active !== 'all' && (
          <button
            type="button"
            onClick={() => onSelect && onSelect('all')}
            className="flex items-center gap-1.5 rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 text-sm font-medium text-slate-500 hover:text-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
            data-testid="sim-count-reset"
          >
            <X className="w-3.5 h-3.5" /> Tout
          </button>
        )}
      </div>
      {onExport && (
        <Button
          onClick={onExport}
          variant="outline"
          className="gap-2 shrink-0"
          disabled={exporting}
          data-testid="sim-export-filtered-btn"
        >
          {exporting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
          Exporter la liste
        </Button>
      )}
    </div>
  );
};

export default SimulationStatusBar;
